import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Island3(props) {
  const { nodes, materials } = useGLTF("/static/ISLA3C.glb");
  return (
    <group {...props} dispose={null}>
      <group position={[165, 0, 100]} scale={0.022}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_1.geometry}
          material={materials["terrain_atlas.terrain.054"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_2.geometry}
          material={materials["terrain_atlas.terrain_alpha.041"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_3.geometry}
          material={materials["terrain_atlas.terrain.055"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_4.geometry}
          material={materials["terrain_atlas.terrain_alpha.042"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_5.geometry}
          material={materials["terrain_atlas.terrain.056"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_6.geometry}
          material={materials["terrain_atlas.terrain.057"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_7.geometry}
          material={materials["terrain_atlas.terrain_alpha.043"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_8.geometry}
          material={materials["terrain_atlas.terrain_alpha.044"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_9.geometry}
          material={materials["terrain_atlas.terrain.058"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_10.geometry}
          material={materials.entity}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_11.geometry}
          material={materials.ui_text_font_default8_blend}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_12.geometry}
          material={materials["terrain_atlas.terrain_alpha.045"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_13.geometry}
          material={materials["terrain_atlas.terrain.059"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_14.geometry}
          material={materials["terrain_atlas.terrain_blend.027"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_15.geometry}
          material={materials["ui_text_font_default8_blend.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_16.geometry}
          material={materials["terrain_atlas.terrain_alpha.046"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_17.geometry}
          material={materials["terrain_atlas.terrain.060"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_18.geometry}
          material={materials["terrain_atlas.terrain_blend.028"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_19.geometry}
          material={materials["ui_text_font_default8_blend.002"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_20.geometry}
          material={materials["terrain_atlas.terrain_alpha.047"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_21.geometry}
          material={materials["terrain_atlas.terrain.061"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_22.geometry}
          material={materials["ui_text_font_default8_blend.003"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_23.geometry}
          material={materials["terrain_atlas.terrain_alpha.048"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_24.geometry}
          material={materials["terrain_atlas.terrain.062"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_25.geometry}
          material={materials["terrain_atlas.terrain_blend.029"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_26.geometry}
          material={materials["ui_text_font_default8_blend.004"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_27.geometry}
          material={materials["terrain_atlas.terrain_alpha.049"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_28.geometry}
          material={materials["terrain_atlas.terrain.063"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_29.geometry}
          material={materials["ui_text_font_default8_blend.005"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_30.geometry}
          material={materials["terrain_atlas.terrain.064"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_31.geometry}
          material={materials["terrain_atlas.terrain_alpha.050"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_32.geometry}
          material={materials["terrain_atlas.terrain_alpha.051"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_33.geometry}
          material={materials["terrain_atlas.terrain.065"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_34.geometry}
          material={materials["terrain_atlas.terrain_alpha.052"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_35.geometry}
          material={materials["terrain_atlas.terrain.066"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_36.geometry}
          material={materials["terrain_atlas.terrain_alpha.053"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_37.geometry}
          material={materials["terrain_atlas.terrain.067"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_38.geometry}
          material={materials["terrain_atlas.terrain_alpha.054"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_39.geometry}
          material={materials["terrain_atlas.terrain.068"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_40.geometry}
          material={materials["ui_text_font_default8_blend.006"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_41.geometry}
          material={materials["terrain_atlas.terrain_alpha.055"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_42.geometry}
          material={materials["terrain_atlas.terrain_blend.030"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_43.geometry}
          material={materials["terrain_atlas.terrain.069"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_44.geometry}
          material={materials["terrain_atlas.terrain_alpha.056"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_45.geometry}
          material={materials["terrain_atlas.terrain.070"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_46.geometry}
          material={materials["terrain_atlas.terrain.071"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_47.geometry}
          material={materials["terrain_atlas.terrain_alpha.057"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_48.geometry}
          material={materials["terrain_atlas.terrain_alpha.058"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_49.geometry}
          material={materials["terrain_atlas.terrain.072"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_50.geometry}
          material={materials["terrain_atlas.terrain.073"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_51.geometry}
          material={materials["terrain_atlas.terrain_alpha.059"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_52.geometry}
          material={materials["terrain_atlas.terrain_blend.031"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_53.geometry}
          material={materials["terrain_atlas.terrain.074"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_54.geometry}
          material={materials["terrain_atlas.terrain_alpha.060"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_55.geometry}
          material={materials["terrain_atlas.terrain.075"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_56.geometry}
          material={materials["terrain_atlas.terrain_alpha.061"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_57.geometry}
          material={materials["terrain_atlas.terrain.076"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_58.geometry}
          material={materials["terrain_atlas.terrain_alpha.062"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_59.geometry}
          material={materials["terrain_atlas.terrain_blend.032"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_60.geometry}
          material={materials["terrain_atlas.terrain_alpha.063"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_61.geometry}
          material={materials["terrain_atlas.terrain.077"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_62.geometry}
          material={materials["terrain_atlas.terrain.078"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_63.geometry}
          material={materials["terrain_atlas.terrain_alpha.064"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_64.geometry}
          material={materials["ui_text_font_default8_blend.008"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_65.geometry}
          material={materials["terrain_atlas.terrain_alpha.065"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_66.geometry}
          material={materials["terrain_atlas.terrain.079"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_0002_67.geometry}
          material={materials["terrain_atlas.terrain_blend.033"]}
        />
      </group>
    </group>
  );
}

useGLTF.preload("/static/Island3.glb");